export const ADMIN_URL = '/admin';
export const REACT_APP_BUSINESS_URL='https://records.4safedrivers.com'
export const APP_BASE_URL= '';